import { configureStore } from '@reduxjs/toolkit'
import { appSlice } from './app'
import { chatReducer } from './chat'
import { horsesReducer } from './horses'
import { reviewsReducer } from './reviews'
import { supportReducer } from './support'
import { withdrawalRequestsReducer } from './withdrawalRequests'

export const store = configureStore({
  reducer: {
    app: appSlice,
    chat: chatReducer,
    horses: horsesReducer,
    reviews: reviewsReducer,
    support: supportReducer,
    withdrawalRequests: withdrawalRequestsReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
